import {Component, tag} from 'doz'

@tag('custom-html')
export default class extends Component {

    template(h) {
        return h`
            <div d-show="${!!this.PLAYER_CONFIG.html}"> 
                ${this.PLAYER_CONFIG.html}
            </div>
        `
    }

}
